import { GridColDef } from "@mui/x-data-grid";
import { TaskDuration } from "../../../models";

export const taskDurationColumns: GridColDef<TaskDuration>[] = [
  { field: "name", headerName: "Name", flex: 1 },
  { field: "duration", headerName: "Duration", flex: 1 },
];
